var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFi14090371(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0043 1.50586C17.8023 1.50586 22.5044 6.20792 22.5044 12.0059C22.5044 17.8039 17.8023 22.506 12.0043 22.506C6.20633 22.506 1.50427 17.8039 1.50427 12.0059C1.50427 6.20792 6.20633 1.50586 12.0043 1.50586ZM9.82387 15.4164L7.25319 12.8436C6.81524 12.4054 6.81515 11.6908 7.25319 11.2527C7.69133 10.8146 8.40911 10.8174 8.84406 11.2527L10.6564 13.0664L15.1648 8.558C15.6029 8.11986 16.3176 8.11986 16.7556 8.558C17.1938 8.99604 17.1931 9.71134 16.7556 10.1489L11.4505 15.454C11.013 15.8915 10.2977 15.8921 9.85965 15.454C9.84734 15.4417 9.83547 15.4292 9.82387 15.4164Z",
    fill: "#00BA00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFi14090371);
export default __webpack_public_path__ + "static/media/fi_14090371.306fa92dd974b5155e8db692fbdce998.svg";
export { ForwardRef as ReactComponent };